import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/Els.jpg"


export const Endlosschleifen = () => {

    return (
        <SongLinks
            title={"Endlosschleifen"}
            coverArt={cover}
            spotifyLink={"https://open.spotify.com/album/1bpbJiHciSHtOFRgXp4xw8"}
            spotifyPresaveLink={"https://add-it.feiyr.com/zebrablau/Endlosschleifen"}
            appleMusicLink={"https://music.apple.com/de/album/endlosschleifen-single/1835471730"}
            appleMusicPresaveLink={undefined}
            youtubeMusicLink={"https://music.youtube.com/watch?v=Aa_S0iGXPPA&list=OLAK5uy_mONZFv9DMijHVKIKikhir2nwGP5Mn3DHg"}
            youtubeLink={undefined}
            tidalLink={"https://tidal.com/album/456309457"}
            amazonMusicLink={"https://www.amazon.com/music/player/albums/B0FNNQ7YYZ"}
            bandcampLink={"https://mondwild.bandcamp.com/track/endlosschleifen"}
            releaseDate={"2025-10-03T00:00:00+02:00"} />
    );
}